import React from 'react';
import BackendPage from '../../components/page/BackendPage';
import Content from '../../components/Content';
import KlaviyoTestForm from '../../components/klaviyo-test/KlaviyoTestForm';

export default function KlaviyoTestPage() {
	return (
		<BackendPage title="Klaviyo Test Events" centerChildren>
			<Content>
				<KlaviyoTestForm />
			</Content>
		</BackendPage>
	);
}
